import {PatientsTabKeys} from '../../constants/Mapping';
import {IWorkFlow} from '../../services/service-mappers/WorkflowMapper';
import {
  CLOSE_SHOW_PATIENT_DRAWER,
  PATIENT_DRAWER_DETAILS,
  SET_ACTIVE_TAB,
  SET_ALL_WORKFLOWS_PATIENTS_DRAWER,
  SET_ELIGIBILITY_NETWORK_APPOINTMENT_DRAWER,
  SET_ELIGIBILITY_VERIFICATION_APPOINTMENT_PATIENT_DRAWER,
  SET_ERROR_PATIENT_DRAWER_DATA,
  SET_LOADING_PATIENT_DRAWER_DATA,
  SET_LOGOUT_AUTH,
  SET_PATIENT_DRAWER_PATIENT_DETAILS
} from '../actions/Index';

export interface PatientDetailsDrawerType {
  open: boolean;
  groupId: number | null;
  clinicId: number | null;
  patientId: number | null;
  activeTab: string;
  patientDetails: any;
  isLoading: boolean;
  isError: boolean;
  error: any;
  eligibilityVerificationAppointment?: any;
  eligibilityNetwork: string | null;
  workflows: IWorkFlow[];
  /** When set, patient drawer Appointments tab shows only this appointment (fetched by id). */
  focusedAppointmentId: number | null;
}
// Defining the initial state for the reducer
const initState: PatientDetailsDrawerType = {
  open: false,
  groupId: null,
  clinicId: null,
  patientId: null,
  activeTab: PatientsTabKeys.PATIENT_DETAILS,
  patientDetails: null,
  isLoading: false,
  isError: false,
  error: null,
  eligibilityNetwork: null,
  workflows: [],
  focusedAppointmentId: null
};

export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case PATIENT_DRAWER_DETAILS:
      return {
        ...state,
        groupId: payload.groupId,
        clinicId: payload.clinicId,
        patientId: payload.patientId,
        patientDetails: payload.patientDetails,
        isLoading: false,
        // if payload has activeTab use it or by default show patient details tab
        activeTab: payload?.activeTab || PatientsTabKeys.PATIENT_DETAILS,
        focusedAppointmentId: (() => {
          const v = payload?.focusedAppointmentId;
          if (v == null || v === '') {
            return null;
          }
          const n = Number(v);
          return Number.isFinite(n) && n > 0 ? n : null;
        })()
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload.activeTab
      };
    case SET_LOADING_PATIENT_DRAWER_DATA: {
      const v = payload?.focusedAppointmentId;
      const nextFocus =
        v == null || v === ''
          ? null
          : (() => {
              const n = Number(v);
              return Number.isFinite(n) && n > 0 ? n : null;
            })();
      return {
        ...state,
        isLoading: true,
        open: true,
        ...(payload && 'focusedAppointmentId' in payload
          ? {focusedAppointmentId: nextFocus}
          : {})
      };
    }
    case SET_ERROR_PATIENT_DRAWER_DATA: {
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: payload
      };
    }

    case SET_PATIENT_DRAWER_PATIENT_DETAILS: {
      return {
        ...state,
        patientDetails: payload.patientDetails
      };
    }
    case SET_ELIGIBILITY_VERIFICATION_APPOINTMENT_PATIENT_DRAWER: {
      return {
        ...state,
        eligibilityVerificationAppointment: payload.appointment
      };
    }
    case SET_ELIGIBILITY_NETWORK_APPOINTMENT_DRAWER: {
      return {
        ...state,
        eligibilityNetwork: payload.eligibilityNetwork
      };
    }
    case SET_ALL_WORKFLOWS_PATIENTS_DRAWER: {
      return {
        ...state,
        workflows: payload.workflows
      };
    }
    case CLOSE_SHOW_PATIENT_DRAWER:
      return initState;
    case SET_LOGOUT_AUTH:
      return initState;
    default:
      return state;
  }
}
